import { render, staticRenderFns } from "./FieldSwitch.vue?vue&type=template&id=59208b5b&scoped=true&"
import script from "./FieldSwitch.vue?vue&type=script&lang=js&"
export * from "./FieldSwitch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59208b5b",
  null
  
)

export default component.exports